<ng-container>
  <!-- Loader -->
  @if (!config?.loaded) {
    <div class="loader-container">
      <div class="spinner"></div>
      <div class="analyzing-text">Analyzing data...</div>
    </div>
  }

  <!-- No Data Message -->
  @if (config?.loaded && config?.noData) {
    <div class="no-data-container">
      <div class="no-data-message">No data available</div>
    </div>
  }

  <!-- Content -->
  @if (config?.loaded && !config?.noData) {
    <div class="output-container">
      <div class="summary-section-html">
        <span class="beta-label float-right">AI generated document(Beta)</span>
        <div [innerHTML]="renderedContent"></div>
      </div>
    </div>
  }
</ng-container>